export const shouldWrapProviderNameText = (
  platinum,
  premium,
  tier1,
  tier2,
  ratings,
  cost,
  preferredProvider,
  preferredFacility,
): boolean =>
  platinum ||
  premium ||
  tier1 ||
  tier2 ||
  ratings ||
  cost ||
  preferredProvider ||
  preferredFacility;
